import { useQuery } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useDashboard = () => {
  return useQuery({
    queryKey: ["dashboard"],
    queryFn: async () =>
      callApi({
        path: "dashboard",
        command: "",
        data: "{}",
      }),
  });
};
